import { useRef, useState } from "react";
import {RiUploadLine} from "react-icons/ri"

/**
 * UploadDropdown Component
 * Groups upload actions (image, pdf/document) under a dropdown menu
 */
export const UploadDropdown = ({ onUploadImage, onUploadDocument, disabled = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleClose = () => setIsOpen(false);

  return (
    <div className="relative" ref={dropdownRef}>
      {/* Dropdown trigger button */}
      <button
        className="p-2 cursor-pointer hover:bg-surface-hover rounded-full disabled:cursor-not-allowed disabled:opacity-50"
        onClick={() => setIsOpen(!isOpen)}
        disabled={disabled}
        title={disabled ? "Send a message first to create this chat before attaching files" : "Upload files"}
        aria-label="Upload files menu"
        aria-expanded={isOpen}
      >
        <RiUploadLine className="w-5 h-5 text-mediumgrey"/>
    
      </button>

      {/* Dropdown menu */}
      {isOpen && (
        <div
          className="absolute bottom-full mb-2 left-0 bg-white border border-surface-border rounded-lg shadow-lg z-50"
          onClick={handleClose}
        >
          <button
            className="w-full px-4 py-2 text-left text-sm text-grey hover:bg-surface-hover flex items-center gap-2 whitespace-nowrap"
            onClick={onUploadImage}
            title="Upload an Image"
          >
            <svg
              className="w-4 h-4"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
            </svg>
            Image
          </button>
          <button
            className="w-full px-4 py-2 text-left text-sm text-grey hover:bg-surface-hover flex items-center gap-2 whitespace-nowrap border-t border-surface-border"
            onClick={onUploadDocument}
            title="Upload a PDF"
          >
            <svg
              className="w-4 h-4"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-8-6z" />
            </svg>
            Document
          </button>
        </div>
      )}

      {/* Click outside handler */}
      {isOpen && (
        <div
          className="fixed inset-0 z-40"
          onClick={handleClose}
        />
      )}
    </div>
  );
};
